export default "407461696c77696e6420626173653b0a0a407461696c77696e6420636f6d706f6e656e74733b0a0a407461696c77696e64207574696c69746965733b0a"